import { render, staticRenderFns } from "./CmsExtraBlocks.vue?vue&type=template&id=15036c58&scoped=true&"
import script from "./CmsExtraBlocks.vue?vue&type=script&lang=js&"
export * from "./CmsExtraBlocks.vue?vue&type=script&lang=js&"
import style0 from "./CmsExtraBlocks.vue?vue&type=style&index=0&id=15036c58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15036c58",
  null
  
)

export default component.exports